export const ORGANIZATION_REQUEST = 'FETCH_TRANSIT'

export function createTransit() {
    return {
    type:'FETCH_TRANSIT'
    }
}




// WEBPACK FOOTER //
// ./src/actions/actionCreators.js